











































import {Vue, Component, Prop} from 'vue-property-decorator';
import {CustomProperty} from 'supporter';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
@Component({
  components: {
    CompSelectBox
  }
})
export default class AdditionalInformation extends Vue {
  @Prop({required: true}) customPropertys!: CustomProperty[];
  @Prop({required: true}) product!: any;
  @Prop({required: true}) immutableFields!: string[];
  @Prop({required: true}) private error!: any;
  @Prop({required: true}) selectBoxList!: any[];

  created() {
    if (this.product.customPropertyValues.length) {
      this.product.customPropertyValues.forEach((value: any) => {
        if (this.isSelectBoxProperty(value)) {
          this.selectBoxList.push(value);
        }
      });
    }
  }

  isSelectBoxProperty(value: any) {
    const customProperty = this.customPropertys.find((property) => property.values.find((propertyValue) => propertyValue === value));
    const propertyValueNo = customProperty.values.find(({propertyValueNo}) => propertyValueNo === value.propertyValueNo).propertyValueNo;
    const filteredSelectBoxList = this.selectBoxList.filter((item) => item !== propertyValueNo );

    if(this.selectBoxList.includes(propertyValueNo)){
      this.$emit('setSelectBoxList', [...filteredSelectBoxList]);

      return;
    }

    this.$emit('setSelectBoxList', [propertyValueNo, ...filteredSelectBoxList]);

    return !(customProperty as CustomProperty).multiSelectionEnabled;
  }

  isSelected(value: any) {
    return this.product.customPropertyValues.includes(value);
  }

  changeSetting(propNo: number, e: Event) {
    const finded = this.customPropertys.find((prop) => prop.propertyNo === propNo);

    if (finded) {
      const value = (e.target as HTMLSelectElement).value;
      const findedNoArr = finded.values.map((value) => value.propertyValueNo);

      if (value) {
        this.$emit('setSelectBoxList', [
          Number((e.target as HTMLSelectElement).value),
          ...this.selectBoxList.filter((no) => {
            return !findedNoArr.includes(no);
          })
        ]);
      } else {
        this.$emit(
          'setSelectBoxList',
          this.selectBoxList.filter((no) => {
            return !findedNoArr.includes(no);
          })
        );
      }
    }
  }
}
